import { format } from 'date-fns';

/** Session-relative offset (matches `DetrixEvent.timestamp` / network `timestamp`). */
export function formatSessionOffset(msSinceSessionStart: number): string {
  return `+${(msSinceSessionStart / 1000).toFixed(3)}s`;
}

export function formatDateTime(isoString: string): string {
  return format(new Date(isoString), 'MMM d, yyyy HH:mm:ss');
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
}
